/**
 * 首页
 */
export default function HomePage() {
  return (
    <div className="min-h-full flex items-center justify-center p-8">
      <p className="text-lg text-default-600">首页尚未开发！</p>
    </div>
  );
}

